@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (box3Bankrekeningen.length > 0) {
      <div formArrayName="box3Bankrekeningen">
        @for (item of box3Bankrekeningen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Naam bank' : ''"
                                              class="custom-input-225"
                                              formControlName="omschrijving"
                                              id="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Rekeningnummer' : ''"
                                              class="custom-input-175"
                                              formControlName="rekeningNummer"
                                              id="rekeningNummer"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Land' : ''"
                                                [options]="optionsLandcodes"
                                                [required]=true
                                                class="custom-input-150"
                                                formControlName="landCode"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Saldo 1 januari' : ''"
                                                [minValue]="0"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                id="bedrag"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Groene rekening' : ''"
                                                [options]="optionsJaNee"
                                                [required]=true
                                                class="custom-input-150 col-auto"
                                                formControlName="groenRekening"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-button (click)="this.showDialog(i)"
                                   [class]="i === 0 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                                   [disabled]="!heeftOWR"
                                   [icon]="'plus'"
                                   type="secondary">
                OWR
              </snelstart-ui-button>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>

              @if (item.get('bedrag')?.value < 0) {
                <snelstart-ui-alert type="danger">
                  Let op! Een bankrekening met een negatief saldo per 1 januari {{ (incomeTaxEntity$ | async)?.year! }} vul je niet in bij 'Bankrekeningen'.
                  Verwijder deze hier en vul deze als 'Overige schuld' in bij de schulden in box 3.
                </snelstart-ui-alert>
              }
            </div>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Bankrekening toevoegen
  </snelstart-ui-button>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" [title]="getOWRDialogTitel(index)" id="owrBank" size="lg">
    <snelstart-ui-dialog-body>
      <form [formGroup]="formGroup">
        @if (box3Bankrekeningen.length > 0) {
          <div formArrayName="box3Bankrekeningen">
            @for (item of box3Bankrekeningen.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if(i === this.index) {
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [minValue]="0"
                                                    [required]=true
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="waardeEindJaar"
                                                    id="bedrag"
                                                    label="Saldo 31 december"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [minValue]="0"
                                                    [required]=true
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="directRendement"
                                                    id="bedrag"
                                                    label="Ontvangen rente"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [required]=true
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="valutaResultaat"
                                                    id="bedrag"
                                                    label="Koerswinst/-verlies"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [disabledControl]=true
                                                    [calculate]="getBerekendeWerkelijkRendement(i)"
                                                    align="right"
                                                    class="custom-input-275 col-auto"
                                                    formControlName="werkelijkRendement"
                                                    id="bedrag"
                                                    label="Werkelijk rendement"
                                                    prefix="€"
                  >
                  </snelstart-ui-number-form-control>

                  @if (item.get('groenRekening')?.value === true) {
                    <snelstart-ui-alert type="warning" class="pt-3">
                      Let op! Als er in de loop van {{ (incomeTaxEntity$ | async)?.year }} een groene belegging (effecten
                      of spaartegoed) is gekocht of verkregen, hoeft het werkelijke rendement hierover nog niet opgenomen
                      te worden in de aangifte over {{ (incomeTaxEntity$ | async)?.year }}.
                    </snelstart-ui-alert>
                  }
                }
              </div>
            }
          </div>
        }
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
      </snelstart-ui-button>
      <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
